import { render, staticRenderFns } from "./live-logout.vue?vue&type=template&id=4eb23c1a&scoped=true"
import script from "./live-logout.vue?vue&type=script&lang=js"
export * from "./live-logout.vue?vue&type=script&lang=js"
import style0 from "./live-logout.vue?vue&type=style&index=0&id=4eb23c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb23c1a",
  null
  
)

export default component.exports